import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MediaPlanService {

  private url = environment.url;

  constructor(private http: HttpClient) { }

  sendEmail(data) {
    return this.http.post(`${this.url}/notaPrensas/data/sendMassNotaPrensa`, data);
  }

  sendEmailReport(data) {
    return this.http.post(`${this.url}/resultadoPlataformas/data/sendReporte`, data);
  }

  sendEmailImpact(data) {
    return this.http.post(`${this.url}/resultadoPlataformas/data/sendImpactosByPlataformas`, data);
  }
}
